import { CircularProgress } from '@mui/material';
import React from 'react';
import GateScheduleService from './services/gate-schedule.service';

interface Props {
  lastUpdate?: string | null;
  isNextWeek?: boolean;
  onDownloadClick: (isNextWeek?: boolean) => void;
  isFetching?: boolean;
  hasData?: boolean;
}

const GateScheduleTableHeader: React.FC<Props> = ({
  lastUpdate,
  isNextWeek,
  onDownloadClick,
  isFetching,
  hasData,
}) => {
  const handleDownloadClick = () => {
    onDownloadClick(isNextWeek);
  };

  const weekDates = GateScheduleService.getStartEndDayOfWeek(isNextWeek);
  const lastUpdateFormatted = GateScheduleService.formatLastUpdateDate(lastUpdate);
  return (
    <div className="gate-schedule-table-wrapper-header">
      <div className="gate-schedule-table-wrapper-header-container">
        <div>
          <div>
            <span className="gate-schedule-table-wrapper-header-week-title">
              {`${isNextWeek ? 'Next' : 'Current'} Week`}
            </span>
            <span className="gate-schedule-table-wrapper-header-week-dates">{weekDates}</span>
          </div>
          <div className="gate-schedule-table-wrapper-header-updated">
            {isFetching && <CircularProgress size={10} className="mr-2" />}
            Updated: {lastUpdateFormatted}
          </div>
        </div>
        {hasData && (
          <div className="gate-schedule-download-button" onClick={handleDownloadClick}>
            Download
          </div>
        )}
      </div>
    </div>
  );
};
GateScheduleTableHeader.displayName = 'GateSchedule.TableHeader';

export default GateScheduleTableHeader;
